<template>
	<div class="page board">
		<!-- board -->
		<section class="secWrap boardWrap">
			<div class="topBgWrap" :style="topBgStyle"></div>
			<div class="pageContentWrap">
				<div class="pageInnerContentHtmlWrap">
					<div class="pageHeaderImg vAlignCenter" v-if="this.receivedData.pageData.mainImg">
						<img :src="$store.getters.getUrlPrefix + this.receivedData.pageData.mainImg" alt="">
					</div>

					<template v-for="(cpItem, index) in receivedData.component">
						<!-- 타이틀, 하단 이미지 n개 표시 및 하단 텍스트 표시 가능 템플릿 -->
						<template v-if="cpItem.componentName === 'boardItem'">
							<MultiImageNTextEdit
								v-if="editModeState"
								class="componentMultiImageNTextEdit"
								:key="index"
								:index="index"
								:componentName = "cpItem.componentName"
								:filePath = "filePath"
								:option = "cpItem.option"
								:title = "cpItem.title"
								:image = "cpItem.image"
								:text = "cpItem.text"
							></MultiImageNTextEdit>
							<MultiImageNText
								v-else
								class="componentMultiImageNTextView"
								:key="index"
								:index="index"
								:componentName = "cpItem.componentName"
								:option = "cpItem.option"
								:title = "cpItem.title"
								:image = "cpItem.image"
								:text = "cpItem.text"
							></MultiImageNText>
						</template>
						<template v-if="cpItem.componentName === 'html'">
							<vue-editor
								v-if="editModeState"
								:customModules="customModulesForEditor"
								:editorOptions="editorSettings"
								:key="index"
								:id="'htmlEdit'+index"
								v-model="receivedData.component[index].html"
							/>
							<div
								v-else
								:key="index"
								v-html="cpItem.html"
							></div>
						</template>
					</template>
					<div class="columns">
						<div class="column is-left">
							<b-button expanded v-if="editModeState" size="is-large">취소</b-button>
						</div>
						<div class="column">
							<b-button @click="sendForm({after:'edit'})" expanded type="is-dark" size="is-large" v-if="editModeState">저장 후 수정</b-button>
						</div>
						<div class="column">
							<b-button @click="sendForm()" expanded type="is-primary" size="is-large" v-if="editModeState">저장</b-button>
						</div>
					</div>
				</div>
			</div>
		</section>
		<Footer/>
	</div>
</template>

<script>
import AOS from 'aos'
import 'aos/dist/aos.css'
import MultiImageNText from '../components/MultiImageNText'
import MultiImageNTextEdit from '../components/MultiImageNTextEdit'
import Footer from '../components/Footer'
import { EventBus } from '../utils/event-bus'
import { VueEditor } from 'vue2-editor'
import { ImageDrop } from 'quill-image-drop-module'
import ImageResize from 'quill-image-resize-module'

export default {
	name: 'boardviewtemplate',
	components: {
		MultiImageNText,
		MultiImageNTextEdit,
		Footer,
		VueEditor
	},
	data () {
		return {
			filePath: '/resources/data/uploadTest/',
			board: {
				background: {
					color: '#fff',
					// image: require('@/assets/images/temp-board-top-img@2x.jpg'),
					image: '',
					size: 'cover',
					position: 'center center',
					width: '100%'
					// height: '284px'
				},
				htmlData: {
					// image: require('@/assets/images/temp-board-top-img@2x.jpg'),
					image: '',
					title: '푸르덴셜생명 모바일 명의 변경(다건) 시스템 구축',
					html: '푸르덴셜생명의 구 시스템에 최초로 다건 시스템을 개발하여<br>명의변경 시스템에 반영, 개편하고 있습니다.<br>전자신청서 및 리모트 서비스 개발 iPad 모바일 서비스 확대<br>사이버창구 개편<br>안내장 카카오 인증기반 전자우편 발송<br>변액 수액율 안내<br>전자약관 발송 시스템 도입<br>FDS 이상금융거래 탐지 연계<br><br>최선을 다하는 두손소프트의 모습을 지켜봐주시고,<br>응원해주시기 바랍니다.<br><br>감사합니다.'
				}
			},
			customModulesForEditor: [
				{ alias: 'imageDrop', module: ImageDrop },
				{ alias: 'imageResize', module: ImageResize }
			],
			editorSettings: {
				modules: {
					imageDrop: true,
					imageResize: {}
				}
			},
			receivedData: {
				pageData: {
					cate: 'news',
					boardNo: '16',
					mainImg: require('@/assets/images/temp-news-item-1@2x.png'),
					title: '푸르덴셜생명 모바일 명의 변경(다건) 시스템 구축',
					shortCont: '푸르덴셜생명의 구 시스템에 최초로 다건 시스템을 개발하여<br>명의변경 시스템에 반영, 개편하고 있습니다.',
					content: '푸르덴셜생명의 구 시스템에 최초로 다건 시스템을 개발하여<br>명의변경 시스템에 반영, 개편하고 있습니다.',
					registDt: '2020.04.02',
					link: '',
					prev: 16,
					next: 14
				},
				editMode: false,
				component: [
					/* {
						componentName: 'boardItem',
						option: [
							{
								name: 'column',
								type: 'number',
								value: 2,
								max: 3,
								min: 1,
								desc: '한 줄에 보일 이미지의 갯수를 설정합니다.'
							},
							{
								name: 'onPadding',
								type: 'boolean',
								value: false
							}
						],
						title: {
							uiType: 'input',
							tag: 'h4',
							text: '활용분야',
							option: [
								{
									name: 'show',
									type: 'boolean',
									value: true
								}
							],
							class: '',
							style: {
								color: '#00ff00',
								padding: '20px 10px 20px 5px',
								margin: '0px auto 20px auto'
							}
						},
						image: {
							uiType: 'files',
							option: [
								{
									name: 'align',
									type: 'string',
									value: 'hcenter' // vcenter: vertical center, hcenter: horizontal center
								}
							],
							items: [
								{
									url: {
										pc: require('@/assets/images/img-solution-fcnote-apply@2x.png'),
										tablet: require('@/assets/images/img-solution-fcnote-apply@2x.png'),
										mobile: require('@/assets/images/img-solution-fcnote-apply@2x.png')
									},
									alt: 'alt Text',
									link: '/portfolio',
									target: ''
								},
								{
									url: require('@/assets/images/temp-industrytrends-item-1@2x.png'),
									alt: 'alt Text',
									link: '',
									target: ''
								},
							]
						},
						text: {
							uiType: 'input',
							option: [
								{
									name: 'show',
									type: 'boolean',
									value: true
								},
								{
									name: 'hyphen',
									type: 'boolean',
									value: true
								}
							],
							items: [
								{
									title: {
										uiType: 'input',
										text: '자동차 보험 현장 조사',
										class: 'custumClassTest custumClassTest2', // 'className1 className2', ...
										style: {
											color: '#ff320a',
											fontSize: '50px'
										}
									},
									text: [
										{
											uiType: 'input',
											text: '자동차 사고시 현장에 출동하여 사고조사 및 처리업무'
										},
										{
											uiType: 'input',
											text: '긴박한 현장 정보들을 사진이미지와 함께 빠르게 필기 메모 가능'
										},
										{
											uiType: 'input',
											text: '작성된 메모들은 업무프로그램으로 관리.'
										},
										{
											uiType: 'input',
											text: '필요시 언제 어느 기기에서나 열람/사용 가능'
										},
										{
											uiType: 'input',
											text: '텍스트 입력 기능 : 색상, 굵기 설정',
											class: '', // 'className1 className2', ...
											style: {
												color: '#32320a',
												fontSize: '24px'
											}
										}
									],
									link: 'link url',
									target: 'target Text'
								},
								{
									title: {
										uiType: 'input',
										text: 'Title Text2',
										class: '', // 'className1 className2', ...
										style: {
											color: '#1f2c95',
											fontSize: '24px'
										}
									},
									text: [
										{
											uiType: 'input',
											text: '푸르덴셜생명의 구 시스템에 최초로',
											class: '', // 'className1 className2', ...
											style: {
												color: '#32320a',
												fontSize: '24px'
											}
										},
										{
											uiType: 'input',
											text: '다건 시스템을 개발하여',
											class: '', // 'className1 className2', ...
											style: {
												color: '#32320a',
												fontSize: '24px'
											}
										},
										{
											uiType: 'input',
											text: '명의변경 시스템에 반영, 개편하고 있습니다.',
											class: '', // 'className1 className2', ...
											style: {
												color: '#32320a',
												fontSize: '24px'
											}
										}
									]
								}
							]
						}
					},
					{
						componentName: 'boardInfo',
						option: [
							{
								name: 'column',
								type: 'number',
								value: 3
							},
							{
								name: 'imgfullWidth',
								type: 'boolean',
								value: true
							},
							{
								name: 'border',
								type: 'boolean',
								value: true
							},
							{
								name: 'optionName1',
								type: 'boolean',
								value: true
							},
							{
								name: 'optionName2',
								type: 'number',
								value: 0
							},
							{
								name: 'optionName3',
								type: 'string',
								value: '...'
							}
						],
						title: {
							uiType: 'input',
							text: 'Title Text',
							option: {
								show: {
									type: 'boolean',
									value: true
								},
								optionName1: {
									type: 'boolean',
									value: true
								},
								optionName2: {
									type: 'number',
									value: 0
								},
								optionName3: {
									type: 'string',
									value: '...'
								}
							},
							class: [
								'className1',
								'className2'
							],
							style: {
								color: '#32320a',
								fontSize: '24px',
								padding: '20px 10px 20px 5px',
								margin: '0px auto 20px auto'
							}
						},
						subTitle: {
							uiType: 'input',
							text: 'Title Text',
							option: [
								{
									name: 'show',
									type: 'boolean',
									value: true
								},
								{
									name: 'optionName1',
									type: 'boolean',
									value: true
								},
								{
									name: 'optionName2',
									type: 'number',
									value: 0
								},
								{
									name: 'optionName3',
									type: 'string',
									value: '...'
								}
							],
							class: [
								'className1',
								'className2'
							],
							style: {
								color: '#32320a',
								fontSize: '24px',
								padding: '20px 10px 20px 5px',
								margin: '0px auto 20px auto'
							}
						},
						image: {
							uiType: 'files',
							option: [
								{
									name: 'onPadding',
									type: 'boolean',
									value: true
								},
								{
									name: 'optionName1',
									type: 'boolean',
									value: true
								},
								{
									name: 'optionName2',
									type: 'number',
									value: 0
								},
								{
									name: 'optionName3',
									type: 'string',
									value: '...'
								}
							],
							items: [
								{
									url: 'url Text',
									alt: 'alt Text',
									link: 'link url',
									target: 'target Text'
								}
							]
						},
						text: {
							uiType: 'input',
							option: [
								{
									name: 'show',
									type: 'boolean',
									value: true
								},
								{
									name: 'hyphen',
									type: 'boolean',
									value: false
								},
								{
									name: 'optionName1',
									type: 'boolean',
									value: true
								},
								{
									name: 'optionName2',
									type: 'number',
									value: 0
								},
								{
									name: 'optionName3',
									type: 'string',
									value: '...'
								}
							],
							items: [
								{
									option: [
										{
											name: 'txtIndent',
											type: 'boolean',
											value: true
										},
										{
											name: 'hyphen',
											type: 'boolean',
											value: false
										},
										{
											name: 'optionName1',
											type: 'boolean',
											value: true
										},
										{
											name: 'optionName2',
											type: 'number',
											value: 0
										},
										{
											name: 'optionName3',
											type: 'string',
											value: '...'
										}
									],
									title: {
										uiType: 'input',
										text: 'Title Text',
										class: [
											'className1',
											'className2'
										],
										style: {
											color: '#32320a',
											fontSize: '24px',
											padding: '20px 10px 20px 5px',
											margin: '0px auto 20px auto'
										}
									},
									text: {
										uiType: 'input',
										text: 'Text',
										class: [
											'className1',
											'className2'
										],
										style: {
											color: '#32320a',
											fontSize: '24px',
											padding: '20px 10px 20px 5px',
											margin: '0px auto 20px auto'
										}
									},
									link: 'link url',
									target: 'target Text'
								}
							]
						}
					},
					{
						componentName: 'html',
						html: '',
						option: [
							{
								name: 'optionName1',
								type: 'boolean',
								value: true
							},
							{
								name: 'optionName2',
								type: 'number',
								value: 0
							},
							{
								name: 'optionName3',
								type: 'string',
								value: '...'
							}
						],
						class: [
							'className1',
							'className2'
						],
						style: {
							color: '#32320a',
							fontSize: '24px',
							padding: '20px 10px 20px 5px',
							margin: '0px auto 20px auto'
						}
					} */
				]
			}
		}
	},
	computed: {
		boardName: function () {
			return this.$route.query.board ? this.$route.query.board : '/'
		},
		topBgStyle: function () {
			var bgUrl = this.receivedData.mainImg ? this.receivedData.mainImg : this.board.background.image
			return {
				backgroundColor: this.board.background.color,
				backgroundImage: 'url(' + this.$store.getters.getUrlPrefix + bgUrl + ')',
				// height: this.board.background.height,
				width: this.board.background.width,
				backgroundSize: this.board.background.size ? this.board.background.size : 'cover',
				backgroundPosition: this.board.background.position ? this.board.background.position : 'center center'
			}
		},
		editModeState: function () {
			var modeState = this.receivedData.editMode
			if (this.$route.query.editMode !== undefined) {
				modeState = this.$route.query.editMode
			}
			return modeState
		}
	},
	watch: {
		receivedData: {
			deep: true,
			immediate: true,
			handler () {
				console.log('The page data has changed!')
			}
		}
	},
	mounted () {
		EventBus.$on('file-upload', (data) => {
			console.log('file upload event received!', data)
			var orgFileName = data.file.name
			var orgFileIdx = data.idx
			var orgFileWithPath = data.orgFileWithPath
			let formData = new FormData()
			formData.append('location', this.filePath)
			formData.append('file', data.file)

			this.$axios.post(this.$store.state.dataUrl + '/fileUpload',
				formData,
				{
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}
			)
				.then(response => {
					console.log('fileUpload Result : ', response.data)
					EventBus.$emit('file-upload-complete' + orgFileName.split('.').slice(0, -1).join('.') + orgFileIdx, {
						file: response.data.resultData,
						filePath: this.filePath,
						orgFile: orgFileName,
						orgFileWithPath: orgFileWithPath,
						idx: orgFileIdx
					})
				})
				.catch(error => {
					console.log('* error : ' + error.response)
				})
		})

		// 파일 삭제
		EventBus.$on('file-delete', (data) => {
			console.log('file delete event received!!', data)
			var pathStr = this.filePath + data.file
			console.log('pathStr:', pathStr)
			this.$axios.post(this.$store.state.dataUrl + '/deleteFile',
				{ fileName: pathStr })
				.then(response => {
					console.log('fileDelete Result : ', response.data)
				})
				.catch(error => {
					console.log('* error : ' + error.response)
				})
		})

		// 데이터 전송
		EventBus.$on('send-form-json', (data) => {
			var afterEdit = false
			if (data.after === 'edit') {
				afterEdit = true
			}
			var sendData = {
				title: this.receivedData.pageData.title,
				cate: this.receivedData.pageData.cate,
				content: this.receivedData.component
			}

			if ((this.$route.query.boardNo !== undefined) && (this.$route.query.boardNo !== null)) {
				sendData.boardNo = this.$route.query.boardNo
				this.$axios.post(this.$store.state.dataUrl + '/updateTest', sendData)
					.then(response => {
						console.log('>> 응답 data : ', response.data)
						this.$buefy.dialog.alert({
							message: '수정하신 내용이 반영 완료되었습니다.',
							onConfirm: () => {
								console.log('페이지 리로드')
								// this.$router.go()
								var path = this.$route.path
								var boardNo = this.$route.query.boardNo
								if (afterEdit) {
									// 저장 후 수정
									this.$router.go()
								} else {
									// 저장 후 보기
									this.$router.push({ path: path, query: { boardNo: boardNo } })
								}
							}
						})
					})
					.catch(error => {
						this.$buefy.dialog.alert({
							message: '죄송합니다. 서비스 장애입니다.<br>전화로 문의 바랍니다.<br>감사합니다.'
						})
						console.log('* error : ' + error.response)
					})
			} else {
				this.$axios.post(this.$store.state.dataUrl + '/insertTest', sendData)
					.then(response => {
						console.log('>> 응답 data : ', response.data)
						this.$buefy.dialog.alert({
							message: '입력하신 내용이 전달 완료되었습니다.',
							onConfirm: () => {
								// this.$router.push('/')
								console.log('this.$route:', this.$route)
								console.log('페이지 리로드')
								// this.$router.go()
							}
						})
					})
					.catch(error => {
						this.$buefy.dialog.alert({
							message: '죄송합니다. 서비스 장애입니다.<br>전화로 문의 바랍니다.<br>감사합니다.'
						})
						console.log('* error : ' + error.response)
					})
			}
		})

		// 템플릿 데이터 호출
		if (this.$route.query.boardNo !== undefined) {
			this.$axios.get(this.$store.state.dataUrl + '/testSelect?boardNo=' + this.$route.query.boardNo)
				.then(response => {
					console.log('template page data : ', response.data)
					console.log('response.data.contentJson:', response.data.contentJson)
					this.receivedData.pageData.cate = response.data.cate
					this.receivedData.pageData.boardNo = response.data.boardNo
					this.receivedData.component = response.data.contentJson
				})
				.catch(error => {
					console.log('* template page data error : ', error.response)
				})
		}
	},
	destroyed () {
		EventBus.$off('file-upload')
		EventBus.$off('file-delete')
		EventBus.$off('send-form-json')
	},
	created () {
		AOS.init({
			duration: 600,
			easing: 'ease-in-sine',
			delay: 100
		})
	},
	methods: {
		sendForm (obj = {}) {
			if (!this.receivedData.component) {
				this.$buefy.dialog.alert('저장할 데이터가 없습니다.')
			} else {
				// 폼 데이터 레디
				EventBus.$emit('send-form-ready-start')
				EventBus.$emit('send-form-json', obj)
			}
		}
	}
}
</script>

<style lang="scss">
@import '@/css/variables.scss';
.board {
	.boardWrap {
		.pageContentWrap {
			.pageInnerContentHtmlWrap {
				$pd: 40px;
				.top,
				.right,
				.bottom,
				.left {
					position: absolute;
				}
				.pageTitle {
					font-size: $title-small;
				}
				.pageHeaderImg {
					position: relative;
					overflow: hidden;
					img { width: 100%; display: block; }
					&.vAlignCenter {
						height: 400px;
						width: 100%;
						img {
							position: absolute;
							width: 100%; height: auto; min-height: auto;
							top: 50%; left: 50%;
							transform: translate(-50%, -50%);
						}
					}
					&.hAlignCenter {
						height: 400px;
						width: 100%;
						img {
							position: absolute;
							width: auto; height: 100%; min-width: auto; max-width: none;
							top: 50%; left: 50%;
							transform: translate(-50%, -50%);
						}
					}
					&.top {top: $pd/2;}
					&.right {right: $pd/2;}
					&.bottom {bottom: $pd/2;}
					&.left {left: $pd/2;}
				}
				.pageHtml {
					img { margin: 0 auto; display: block;}
				}
			}
		}
	}
}
</style>

<style lang="scss" scoped>
@import '@/css/variables.scss';
.board {
	position: relative;
	padding-top: 88px;
	height: auto;
	width: 100%;
	background-color: $c-white;
	.boardWrap {
		position: relative;
		width: 100%;
		margin: 0 auto;
		padding: 0;
		.topBgWrap {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			/* height: 284px; */
			height: 400px;
			opacity: 0.3;
			z-index: 0;
		}
		.pageContentWrap {
			position: relative;
			margin: 0 auto;
			.pageInnerContentHtmlWrap {
				padding-top: 40px;
				padding-bottom: 80px;
				min-height: 600px;
				/* page content area */
			}
			.pagingBtnsWrap {
				display: flex;
				justify-content: space-between;
				margin-bottom: 80px;
				.btn {
					width: 25%;
					padding: 16px 0;
					text-align: center; font-size: $text-normal;
					border: 1px solid $c-gray-m;
					color: $c-gray-black;
					font-weight: bold;
					&.btnList {
						background-color:$c-gray-bright;
					}
				}
			}
		}
	}
	.btnMore {
		display: block;
		width: 100%;
		height: 90px;
		text-align: center;
		font-size: $text-medium; color: $c-white;
		background-color: $c-gray-m;
		.icon {margin-left: 8px;}
	}
}

/*
	##Device = Tablets, Ipads (portrait)
	##Screen = B/w 768px to 1024px
*/
@media (min-width: 768px) and (max-width: 1024px) {
	.board {
		padding-top: 74px;
		.boardWrap {
			.topBgWrap {
				height: 160px;
				opacity: 0.2;
			}
			.pageContentWrap {
				.pageInnerContentHtmlWrap {
					padding: 40px 12px 60px 12px;
					min-height: 600px;
					/* page content area */
					.pageTitle {
						margin: 20px 0;
						font-size: $title-normal-small;
						letter-spacing: $lspace-short;
					}
				}
				.pagingBtnsWrap {
					margin-bottom: 40px;
					.btn {
						padding: 10px 0;
						font-size: $text-small;
					}
				}
			}
		}
	}
}

/*
	##Device = Tablets, Ipads (landscape)
	##Screen = B/w 768px to 1024px
*/
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
	//CSS
}

/*
	##Device = Low Resolution Tablets, Mobiles (Landscape)
	##Screen = B/w 481px to 767px
*/

@media (min-width: 481px) and (max-width: 767px) {
}

/*
	##Device = Most of the Smartphones Mobiles (Portrait)
	##Screen = B/w 320px to 479px
*/
@media (min-width: $mnWMobile) and (max-width: 480px) {
	.board {
		padding-top: 74px;
		.boardWrap {
			.topBgWrap {
				max-height: 156px;
				opacity: 0.2;
			}
			.pageContentWrap {
				.pageInnerContentHtmlWrap {
					padding: 40px 12px 60px 12px;
					min-height: 600px;
					/* page content area */
					.pageTitle {
						margin: 20px 0 10px;
						font-size: $title-xxsmall;
						letter-spacing: $lspace-short;
					}
				}
				.pagingBtnsWrap {
					padding: 0 12px;
					margin-bottom: 40px;
					.btn {
						padding: 10px 0;
						font-size: $text-small;
					}
				}
			}
		}
	}
}
</style>
